import {Container, Grid, Typography} from '@mui/material';
import React from 'react';
import DocumentTile, {
  IBates,
} from '../../../components/common/arr-document-tile/ArrDocumentTile';

const DocumentTileDemo: React.FC = () => {
  const metaDataList = [{label: 'Documents', value: '2,333'}];
  const metaDataList2 = [
    {label: 'Source', value: '0'},
    {label: 'Injested', value: '0'},
    {label: 'Errors', value: '0'},
  ];
  const metaDataList3 = [
    {label: 'Uploaded', value: '1,200'},
    {label: 'Released', value: '1,110'},
    {label: 'Errors', value: '0'},
  ];
  const bates: IBates = {
    startNumber: 'ARR11222620254567775454554431241242414',
    endNumber: 'ARR999999882727275454544132431413241413241',
  };
  return (
    <Container className="document-tile-demo">
      <Typography variant="h5" className="document-tile-demo-title">
        Document Tile
      </Typography>
      <Grid container spacing={1}>
        <Grid size={{xs: 12, sm: 6, md: 3}}>
          <DocumentTile
            primaryLabel="Title of Content Title of Content Post-Gen QC Checks Complete"
            tertiaryLabel="Post-Gen QC Checks Complete Title of Content Title of Content Post-Gen QC Checks Complete"
            primaryLabelColor="text-action-default"
            lastModifiedBy="Firstname Lastname"
            lastModifiedTimestamp="2025/02/06 14:26:36"
            statusTimestamp="Status Label 2025/02/06 14:26:36"
            metaDataList={metaDataList}
            bates={bates}
            actionMenuItems={[
              {
                id: '1',
                label: 'Open in Wizard',
                onClick: () => console.log('open'),
              },
              {id: '2', label: 'Delete', onClick: () => console.log('Delete')},
              {
                id: '3',
                label: 'Save as Template',
                onClick: () => console.log('Save as Template'),
              },
            ]}
            progressBarProps={{
              percent: 50,
              state: 'in-progress',
            }}
          ></DocumentTile>
        </Grid>
        <Grid size={{xs: 12, sm: 6, md: 3}}>
          <DocumentTile
            primaryLabel="Title of Content"
            secondaryLabel="Project Name"
            status="Completed"
            primaryLabelColor="text-action-default"
            secondaryLabelColor="text-body-subtle"
            lastModifiedBy="Firstname Lastname"
            lastModifiedTimestamp="2025/02/06 14:26:36"
            statusTimestamp="Status Label 2025/02/06 14:26:36"
            metaDataList={metaDataList2}
            progressBarProps={{
              percent: 100,
              state: 'completed',
            }}
          ></DocumentTile>
        </Grid>
        <Grid size={{xs: 12, sm: 6, md: 3}}>
          <DocumentTile
            primaryLabel="Title of Content"
            secondaryLabel="Project Name"
            status="Completed"
            secondaryLabelColor="text-body-subtle"
            lastModifiedBy="Firstname Lastname"
            lastModifiedTimestamp="2025/02/06 14:26:36"
            statusTimestamp="Status Label 2025/02/06 14:26:36"
            metaDataList={metaDataList3}
            progressBarProps={{
              percent: 65,
              state: 'success',
            }}
          ></DocumentTile>
        </Grid>
        <Grid size={{xs: 12, sm: 6, md: 3}}>
          <DocumentTile
            primaryLabel="Title of Content"
            secondaryLabel="Project Name"
            status="Completed"
            secondaryLabelColor="text-body-subtle"
            lastModifiedBy="Firstname Lastname"
            lastModifiedTimestamp="2025/02/06 14:26:36"
            statusTimestamp="Status Label 2025/02/06 14:26:36"
            metaDataList={metaDataList3}
            progressBarProps={{
              percent: 15,
              state: 'in-progress',
            }}
          ></DocumentTile>
        </Grid>
        <Grid size={{xs: 12, sm: 6, md: 3}}>
          <DocumentTile
            primaryLabel="Title of Content"
            secondaryLabel="Project Name"
            status="Completed"
            secondaryLabelColor="text-body-subtle"
            lastModifiedBy="Firstname Lastname"
            lastModifiedTimestamp="2025/02/06 14:26:36"
            statusTimestamp="Status Label 2025/02/06 14:26:36"
            metaDataList={metaDataList3}
            progressBarProps={{
              percent: 0,
              state: 'draft',
            }}
          ></DocumentTile>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DocumentTileDemo;
